import './VifPracticeMenu.scss';

export interface VifPracticeMenuProps {
  /** Legacy `gameFrame.roundsInModule`: rounds beyond it are hidden. */
  roundsInModule: number;
  onChooseRound: (round: number) => void;
  /** Where the More Games button goes. Legacy `params.hubUrl`. */
  hubUrl?: string;
}

/**
 * The pre-game dialogue, rebuilt in the DOM from `gameFrame.practiceMenu`.
 *
 * The canvas build opens on it whenever a login cannot be scored against
 * saved progress - preview/admin logins, a player who has finished earning, a
 * saved round outside the module's range, or a failed progress fetch
 * (`framework/GameFrame.ts:296-326`). Picking a round starts that round at
 * game 1 (`clickRoundBtn`, `:609-617`).
 *
 * Only `roundsInModule` buttons are offered; the canvas symbol carries four
 * and hides the surplus (`framework/GameFrame.ts:257-267`).
 *
 * The heading is new text. Unlike the end-screen copy, the practice menu's
 * wording is vector artwork in the composition with no underlying string, the
 * same problem the rules panel has (see `core/rulesAddSubCopy.ts`).
 */
export function VifPracticeMenu({
  roundsInModule,
  onChooseRound,
  hubUrl,
}: VifPracticeMenuProps) {
  return (
    <div className="vif-practice-menu" role="dialog" aria-modal="true">
      <div className="vif-practice-menu__panel">
        <h2 className="vif-practice-menu__title">Choose a Round</h2>

        <div className="vif-practice-menu__rounds">
          {Array.from({ length: Math.max(roundsInModule, 1) }, (_, index) => (
            <button
              key={index}
              type="button"
              className="vif-practice-menu__round"
              onClick={() => {
                onChooseRound(index + 1);
              }}
            >
              Round {index + 1}
            </button>
          ))}
        </div>

        <a className="vif-practice-menu__more" href={hubUrl ?? '#'}>
          More Games
        </a>
      </div>
    </div>
  );
}
